const comments = Vue.createApp(jdw.components.Comments)

comments.mount('#v-comments')
jdw.apps.comments = comments